import { render, staticRenderFns } from "./AttributeInputRow.vue?vue&type=template&id=4c158cdc&scoped=true"
import script from "./AttributeInputRow.vue?vue&type=script&lang=ts&setup=true"
export * from "./AttributeInputRow.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./AttributeInputRow.vue?vue&type=style&index=0&id=4c158cdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c158cdc",
  null
  
)

export default component.exports